import styled from 'styled-components';
import { Heading01, Short01 } from '../../styles';
import { ActionFooter } from '../action-footer';

export const Divider = styled.div`
  border-top: 1px solid var(--border-color);
`;

const TextWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing?.normal};
  padding-right: 15% !important;
`;
const Text = styled(TextWrapper)`
  padding: 0;
`;

export const Title = styled.div.attrs({ as: Text })`
  ${Heading01};
`;

export const Content = styled.div.attrs({ as: Text })`
  ${Short01};
`;

const PopoverComponent = styled.div`
  --popover-spacing: var(--spacing-05);
  display: flex;
  width: 356px;
  flex-direction: column;
  align-items: stretch;

  ${Title} {
    margin: var(--popover-spacing) var(--popover-spacing)
      calc(var(--popover-spacing) / 2);
  }

  ${Content} {
    margin: 0 var(--popover-spacing) calc(2 * var(--popover-spacing));
  }

  ${ActionFooter} {
    margin: calc(var(--popover-spacing) / 2) var(--popover-spacing);
  }

  ${Divider} {
    margin-top: var(--popover-spacing);
  }
`;

type Popover = typeof PopoverComponent & {
  Title: typeof Title;
  Content: typeof Content;
  Divider: typeof Divider;
};

const Popover: Popover = PopoverComponent as any;

Popover.Title = Title;
Popover.Content = Content;
Popover.Divider = Divider;

export { Popover };
